import React from 'react';
import Header from '../components/Header/Header';
import AdvantagesDetail from '../components/AdvantagesDetail/AdvantagesDetail';
import Footer from '../components/Footer/Footer';
import FooterCTA from '../components/FooterCTA/FooterCTA';

const AdvantagesPage = () => {
  return (
    <>
      <Header />
      <main>
        <AdvantagesDetail />
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default AdvantagesPage;